/**
 * Client-side SO/PO list search — number, party name, external ref (plan/24).
 */
/** Case-insensitive substring match. Empty query matches all. */
export function matchesOrderListQuery(query, fields) {
    const q = query.trim().toLowerCase();
    if (!q)
        return true;
    const hay = [fields.number, fields.partyName, fields.externalRef]
        .filter((s) => Boolean(s && s.trim()))
        .join(" ")
        .toLowerCase();
    return hay.includes(q);
}
